module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Wohlen_AG-9f7aebcd7a237aa7268e1729a319a812.svg";